import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axiosInstance from '../axiosConfig';
import Meta from "../components/Meta";
import Loader from "../components/Loader";

const PaymentSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate(); 
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyPayment = async () => {
      const queryParams = new URLSearchParams(location.search);
      const paymentRequestId = queryParams.get('payment_request_id');
      const paymentStatus = queryParams.get('payment_status');
      if (paymentStatus) {
        try {
          setLoading(true);
          const successForm = {
            payment_request_id: paymentRequestId,
            payment_status: paymentStatus,
          };
          const response = await axiosInstance.post('verify-payment', successForm);
          if (response.data.success) {
            // navigate('/thank-you'); 
            navigate('/thank-you', { state: { paymentRequestId, paymentStatus } });
          } else {
            navigate('/payment-failed');
          }
        } catch (error) {
          navigate('/payment-failed');
        }
        finally {
          setLoading(false);
        }
      } else {
        navigate('/payment-failed');
      }
    };

    verifyPayment(); 
  }, [location, navigate]); 


  if(loading){
    return <Loader />;
  }

    return (
      <>
      <Meta title="Payment Success - THE CUTTING BAR" />
      <h1>Processing Payment...</h1>
    </>
    );
 };

export default PaymentSuccess;

